import colors from '@sportninja/common/constants/appColors'
import React from 'react'

interface MultipleDivisionsIconProps {
  color?: string
  size?: number
}

/**
 * Multiple Divisions icon for competition setup wizard
 */
const MultipleDivisionsIcon: React.FC<MultipleDivisionsIconProps> = ({
  color = colors.PRIMARY,
  size = 40,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 40 40'
      fill='none'
    >
      <path
        d='M6.66667 23.3335H10C10.9167 23.3335 11.6667 22.5835 11.6667 21.6668V18.3335C11.6667 17.4168 10.9167 16.6668 10 16.6668H6.66667C5.75 16.6668 5 17.4168 5 18.3335V21.6668C5 22.5835 5.75 23.3335 6.66667 23.3335ZM6.66667 31.6668H10C10.9167 31.6668 11.6667 30.9168 11.6667 30.0002V26.6668C11.6667 25.7502 10.9167 25.0002 10 25.0002H6.66667C5.75 25.0002 5 25.7502 5 26.6668V30.0002C5 30.9168 5.75 31.6668 6.66667 31.6668ZM6.66667 15.0002H10C10.9167 15.0002 11.6667 14.2502 11.6667 13.3335V10.0002C11.6667 9.0835 10.9167 8.3335 10 8.3335H6.66667C5.75 8.3335 5 9.0835 5 10.0002V13.3335C5 14.2502 5.75 15.0002 6.66667 15.0002ZM15 23.3335H33.3333C34.25 23.3335 35 22.5835 35 21.6668V18.3335C35 17.4168 34.25 16.6668 33.3333 16.6668H15C14.0833 16.6668 13.3333 17.4168 13.3333 18.3335V21.6668C13.3333 22.5835 14.0833 23.3335 15 23.3335ZM15 31.6668H33.3333C34.25 31.6668 35 30.9168 35 30.0002V26.6668C35 25.7502 34.25 25.0002 33.3333 25.0002H15C14.0833 25.0002 13.3333 25.7502 13.3333 26.6668V30.0002C13.3333 30.9168 14.0833 31.6668 15 31.6668ZM13.3333 10.0002V13.3335C13.3333 14.2502 14.0833 15.0002 15 15.0002H33.3333C34.25 15.0002 35 14.2502 35 13.3335V10.0002C35 9.0835 34.25 8.3335 33.3333 8.3335H15C14.0833 8.3335 13.3333 9.0835 13.3333 10.0002Z'
        fill={color}
      />
    </svg>
  )
}

export default MultipleDivisionsIcon
